module.exports = {
	"pageTitle": "Subject to change | totaljobs",
	"pageDescription": "Is ‘covering’ the biggest unspoken secret of UK work-life?",
	"tweetText": "Do you hide your true self at work to win praise, promotion to even just acceptance? You’re not the only one. Discover ‘covering’ in the workplace with @totaljobsuk.",
	"verbalChangesTitle": "Verbal changes",
	"verbalChangesStandfirstPer": "45",
	"verbalChangesStandfirst": "Remarkably, 45% of people think it's normal to change the way you speak at work.",
	"verbalChangesText1": "And maybe it’s not surprising we’re hiding our true voices 🤐",
	"verbalChangesText2per": "13",
	"verbalChangesText2": "13% of you admit to having thought less of someone or mocked 😓 someone at work because of their accent.",
	"verbalChangesText3": "For people with accents, work isn’t always a safe space.",
	"verbalChangesText4feeling": "mocked",
	"verbalChangesText5feeling": "ashamed",
	"verbalChangesText4": "% of respondents who were mocked vs.",
	"verbalChangesText5": "% of respondents who felt ashamed",
	"verbalChangesViz1": [
		{
			"fact": "At work",
			"description": "Work is the place we're most likely to be mocked for our accents or feel ashamed of them",
			"percentage": "36, 12"
		},
		{
			"fact": "With friends",
			"percentage": "35, 5"
		},
		{
			"fact": "With strangers",
			"percentage": "20, 9"
		},
		{
			"fact": "At school",
			"percentage": "17, 5"
		},
		{
			"fact": "At university",
			"description": "Uni is the place we're least likely to feel ashamed of our accents",
			"percentage": "11, 4"
		},
		{
			"fact": "Interview",
			"description": "Job interviews are where we often feel ashamed of our accents, yet are least likely to be mocked",
			"percentage": "5, 9"
		}
	],
	"verbalChangesViz2Title": "Maybe it’s not surprising, then, that people are more likely to tone down their accent for a job interview 📝 than for a date 💕",
	"verbalChangesViz2Emoji": "😶",
	"verbalChangesViz2": [
		{
			"respondents": "4",
			"totalRespondents": "10",
			"text": "4 in 10 respondents with an accent would tone it down in a job interview",
			"highlight": "4 in 10"
		},
		{
			"respondents": "2",
			"totalRespondents": "10",
			"text": "2 in 10 respondents with an accent would tone it down on a date",
			"highlight": "2 in 10"
		}
	],
	"verbalChangesViz3Title": "Oh, and as for swearing on the job?",
	"verbalChangesViz3": [
		{
			"fact": "swear in front of grandparents",
			"percentage": "16"
		},
		{
			"fact": "swear in front of clients",
			"percentage": "7"
		}
	],
	"verbalChangesViz4Title": "And here are the justifications they gave…",
	"verbalChangesViz4": [
		{
			"factEmoji": "🖥",
			"fact": "“I swear at my computer. It is a shame I cannot do more to it in order to make it behave”"
		},
		{
			"factEmoji": "🔪",
			"fact": "“If you cut your hand with a knife what are you supposed to say?”"
		},
		{
			"factEmoji": "🗣",
			"fact": "“Banter with others”"
		},
		{
			"factEmoji": "‼️",
			"fact": "“To act like a normal f****** person”"
		},
		{
			"factEmoji": "🌸",
			"fact": "“Not heavy swearing, just things like damn, blooming”"
		},
		{
			"factEmoji": "❌",
			"fact": "“Only with trusted colleagues and no women around”"
		},
		{
			"factEmoji": "💨",
			"fact": "“Release :)”"
		},
		{
			"factEmoji": "😶",
			"fact": "“I only swear quietly\""
		}
	],
	"personalityChangesTitle": "Personality changes",
	"personalityChangesStandfirstPer": "52",
	"personalityChangesStandfirst": "Most dramatically of all, 52% think people should change their personality 🎭 at work.",
	"personalityChangesText1": "And it seems to make a difference.",
	"personalityChangesText2": "When people change their personality at work, they feel much more comfortable 🛀 and confident 😜... Yet they also feel more stressed 😫",
	"personalityChangesViz1Title": "% of respondents who change their personality and feel...",
	"personalityChangesViz1SubTitle": [
		{
			"title": "Negative feelings 👎🏼"
		},
		{
			"title": "👍🏼 Positive feelings"
		}
	],
	"personalityChangesViz1": [
		{
			"fact": "Amused",
			"percentage": "11"
		},
		{
			"fact": "Confident",
			"percentage": "43"
		},
		{
			"fact": "Comfortable",
			"percentage": "46"
		},
		{
			"fact": "Stressed",
			"percentage": "28"
		},
		{
			"fact": "Exposed",
			"percentage": "11"
		},
		{
			"fact": "Ashamed",
			"percentage": "7"
		}
	],
	"personalityChangesViz2Pop1": "Women",
	"personalityChangesViz2Pop2": "men",
	"personalityChangesViz2Title": "Women find changing their personality at work more stressful than men do",
	"personalityChangesViz2": [
		{
			"fact": "of men",
			"percentage": "25",
			"color": "#B3F36C"
		},
		{
			"fact": "of all",
			"percentage": "28",
			"color": "#fff"
		},
		{
			"fact": "of women",
			"percentage": "32",
			"color": "#17ADA1"
		}
	],
	"personalityChangesViz3Pop1": "straight men",
	"personalityChangesViz3Pop2": "LGBTQ+",
	"personalityChangesViz3Title": "And straight men feel more comfortable changing their personalities compared to LGBTQ+ respondents",
	"personalityChangesViz3": [
		{
			"fact": "of LGBTQ+",
			"percentage": "38",
			"color": "#FECA98"
		},
		{
			"fact": "of all",
			"percentage": "46",
			"color": "#709EEB"
		},
		{
			"fact": "of straight men",
			"percentage": "50",
			"color": "#86C93D"
		}
	],
	"personalityChangesViz4Title": "Why might these be the groups of people that feel least comfortable and most stressed? Perhaps it’s because…",
	"personalityChangesViz4Emoji": "👌🏾",
	"personalityChangesViz4": [
		{
			"respondents": "7",
			"totalRespondents": "10",
			"text": "7 in 10 respondents think we should stick up for groups such as women, LGBTQ+ and disabled people at work",
			"highlight": "7 in 10"
		},
		{
			"respondents": "5",
			"totalRespondents": "10",
			"text": "But only 5 in 10 respondents say they actually do",
			"highlight": "5 in 10"
		}
	],
	"personalityChangesViz5Title": "Here's how changing their personality made people feel…",
	"personalityChangesViz5": [
		{
			"factEmoji": "🔪",
			"fact": "“Safer from back-stabbers”"
		},
		{
			"factEmoji": "👽",
			"fact": "“Alien”"
		},
		{
			"factEmoji": "👑",
			"fact": "“IN CONTROL”"
		},
		{
			"factEmoji": "🎨",
			"fact": "“Like I’m hiding my true colours”"
		},
		{
			"factEmoji": "🛡",
			"fact": "“Armoured (protected)”"
		},
		{
			"factEmoji": "👏🏽",
			"fact": "“To appear like putty in their hands, when actually I have manipulated them into getting projects finished in a timely manner”"
		},
		{
			"factEmoji": "📌",
			"fact": "“It’s what needs to be done to be professional. That’s that”"
		}
	],
	"conclusionTitle": "Conclusion",
	"conclusionStandfirst": "But what happens when a company encourages you to be your true self 👯?",
	"conclusionViz1Title": "There’s a clear relationship between being inclusive in the workplace and job satisfaction.",
	"conclusionViz1Emoji": "😕",
	"conclusionViz1Emoji2": "😊",
	"conclusionViz1": [
		{
			"respondents": "5",
			"totalRespondents": "10",
			"text": "Of those respondents that are dissatisfied ☹️ with their job, 5 in 10 work for an inclusive company",
			"highlight": "5 in 10"
		},
		{
			"respondents": "8",
			"totalRespondents": "10",
			"text": "Of those respondents that are satisfied 😊 with their job, 8 in 10 work for an inclusive company",
			"highlight": "8 in 10"
		}
	],
	"conclusionText1": "But does that mean you’re more likely to be true to yourself if you work at an inclusive company?",
	"conclusionText2": "🤔 Interestingly, no...",
	"conclusionText3": "Even if you work for a company that’s inclusive, people still feel the need to change who they are at work 🙃",
	"conclusionText4": "Of those respondents that work for an inclusive company…",
	"conclusionText5": "Of those respondents that don’t work for an inclusive company…",
	"conclusionViz2SubTitle": [
		{
			"title": "Of those respondents that work for an inclusive company…"
		},
		{
			"title": "Of those respondents that don’t work for an inclusive company…"
		}
	],
	"conclusionViz2": [
		{
			"fact": "change their personality",
			"percentage": "52"
		},
		{
			"fact": "change their personality",
			"percentage": "52"
		}
	],
	"relatedContentTitle": "Keep exploring your work-self",
	"relatedContent": [
		{
			"name": "Covering your true self",
			"desc": "Why do we often feel we can't be our true self at work?",
			"image": "assets/personality.svg",
			"url": "https://www.totaljobs.com/insidejob/bringing-your-true-self-to-work/"
		},
		{
			"name": "Displaced in the workplace",
			"desc": "LGBTQ+ advocate Rhammel Afflick explores our research on covering.",
			"image": "assets/lgbtq.svg",
			"url": "https://www.totaljobs.com/insidejob/lgbtq-people-continue-to-feel-displaced-in-the-workplace/"
		}
	],
	"sourceTitle": "Survey data",
	"sourceText": "Totaljobs research of 4,127 UK workers in May 2018."
};


//////////////////
// WEBPACK FOOTER
// ./copy.txt
// module id = YUl8
// module chunks = 0